import {
  findCurrentAgencies,
  findCurrentBroker,
} from "../report/reportActions";

const transformReportInput = (values, reportType) => (state) => {
  const agency = findCurrentAgencies(state, values.AgencyKeys);
  const brokerName = findCurrentBroker(state);

  return {
    ...values,
    AgencyNameAndNumber: agency.FullName,
    FileName: `${reportType}_${agency.Number}`,
    BrokerName: brokerName,
  };
};

export const transformScheduleOfVehiclesInput = (values) =>
  transformReportInput(values, "ScheduleOfVehicles");

export const transformConfirmationOfInsuranceInput = (values) =>
  transformReportInput(values, "ConfirmationOfInsurance");